import React, { Component } from "react";
import { Route, HashRouter, Switch } from "react-router-dom";

import Home from "./components/home/Home.js";
import ControlPanel from "./components/controlPanel/ControlPanel";
import Admin from "./components/tenantAdmin/Admin.js";

import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import ForgotUsername from "./components/auth/ForgotUsername";
import ForgotPassword from "./components/auth/ForgotPassword";
import PasswordReset from "./components/auth/PasswordReset";
import CompleteRegistration from "./components/auth/CompleteRegistration";
import ConfirmAlertEmail from "./components/auth/ConfirmAlertEmail.js";
import {PrivateRoute} from "./components/auth/PrivateRoute.js";

export default class App extends Component {

  render() {
      return (
        <HashRouter>
          <div className="App">
          <div style={{maxWidth:2000, margin:'0 auto'}} className="content">
          <Switch>
            <Route exact path="/" component={Login} />
            <Route path="/login" component={Login} />
            <Route path="/home" component={Home} />
            <Route path="/register" component={Register} />
            <Route path="/passwordReset/:ticket" component={PasswordReset} />
            <Route path="/CompleteRegistration/:ticket" component={CompleteRegistration} />
            <Route path="/ConfirmEmail/:ticket" component={ConfirmAlertEmail} />
            <Route path="/forgotUsername" component={ForgotUsername} />
            <Route path="/forgotPassword" component={ForgotPassword} />            
             <PrivateRoute path="/tenantAdmin" component={Admin} />
            <PrivateRoute path="/controlPanel" component={ControlPanel} />
          </Switch>
          </div>
        </div>
      </HashRouter >

    );
  }
}